import styled from "@emotion/styled";
import colors from "/styles/colors";
import { MOBILE_QUERY_MAX_WIDTH, SMALL_MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
export const StyledAssetStripComponent = styled.div`
  position: relative;
  width: 100vw;
  max-width: 100%;

  overflow: hidden;

  img {
    min-width: 100%;
  }

  .asset-strip-content {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;

    .strip-signup-wrapper {
      margin-top: 32px;
    }

    .strip-title {
      color: ${colors["white"]};
      font-size: 2.7rem;
      font-weight: 700;

      margin-bottom: 24px;
      padding: 0 48px;
    }

    .strip-subtitle {
      color: ${colors["white"]};
      font-size: 1.375rem;

      margin-bottom: 24px;
      padding: 0 48px;
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .asset-strip-content {
      .strip-title {
        font-size: 2.25rem;

        margin-bottom: 24px;
        padding: 0 24px;
      }

      .strip-subtitle {
        font-size: 1.375rem;

        margin-bottom: 24px;
        padding: 0 24px;
      }
    }
  }

  @media (max-width: ${SMALL_MOBILE_QUERY_MAX_WIDTH}) {
    .asset-strip-content {
      .strip-title {
        font-size: 1.75rem;
      }

      .strip-subtitle {
        font-size: 1.125rem;
      }
    }
  }
`;
